// SPDX-License-Identifier: MIT
// TS bridge between Plan 1's pure GenesisFileMap and the path-jailed Rust commands
// write_genesis_files / read_genesis_files. writeGenesisToDir serializes a state and
// writes the five .genesis/ files into the project dir (so the existing code push
// carries them); readGenesisFromDir reads them back from a freshly cloned dir.
import { tauriInvoke } from './tauri';
import { serializeGenesisState, type GenesisState, type GenesisFileMap } from './genesis-state';

export const GENESIS_FILES = [
  '.genesis/project.json',
  '.genesis/versions.json',
  '.genesis/sessions.json',
  '.genesis/meta.json',
  '.genesis/backend.json',
] as const;

export async function writeGenesisToDir(dir: string, state: GenesisState): Promise<void> {
  const map = serializeGenesisState(state);
  const files = Object.entries(map).map(([name, content]) => ({ name, content }));
  await tauriInvoke()('write_genesis_files', { dir, files });
}

export async function readGenesisFromDir(dir: string): Promise<GenesisFileMap> {
  const names = [...GENESIS_FILES];
  const contents = (await tauriInvoke()('read_genesis_files', { dir, names })) as (string | null)[];
  const map: GenesisFileMap = {};
  names.forEach((name, i) => {
    const c = contents?.[i];
    if (typeof c === 'string') map[name] = c;
  });
  return map;
}
